import { render, staticRenderFns } from "./ModaNumBillComponent.vue?vue&type=template&id=9bc1634a"
import script from "./ModaNumBillComponent.vue?vue&type=script&lang=js"
export * from "./ModaNumBillComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports